import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-graphql-table';
import query from './query.graphql';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;

const MSNominationsTab = ({ currTimepoint, renderTimepointPills, classIdsWithMsClimateSurvey }) => {
    let labelSingle = 'Class';
    let labelPlural = 'Classes';
    try {
        const groupDef = Appdefs.pawn.groups.find(g => g.handle === 'class');
        labelSingle = groupDef.label;
        labelPlural = groupDef.labelPlural;
    } catch (e) {
        // meh, use defaults
    }

    let columns = [
        { name: 'user.username', label: 'Student ID', sort: true, filter: true },
        { name: 'user.firstName', label: 'First Name', sort: true, filter: true },
        { name: 'user.lastName', label: 'Last Name', sort: true, filter: true },
        { name: 'ancestorGroups.site.group.label', label: 'School', sort: true, filter: true },
        { name: 'ancestorGroups.class.group.label', label: 'Class', sort: true, filter: true },
        {
            name: 'completionStatus',
            label: 'Status',
            sort: true,
            filter: true,
            filterSettings: {
                type: 'selectbox',
                options: [
                    { label: 'Not Started', value: 'Not Started' },
                    { label: 'In Progress', value: 'In Progress' },
                    { label: 'Complete', value: 'Complete' },
                ],
            },
        },
        {
            name: 'assignmentProgress.devTags.ms_pn_spend_time',
            label: 'Spend Time',
            tooltip: 'Name up to 5 peers in your grade who you like to spend time with.',
            sort: true,
            filter: true,
            width: '30%',
        },
        {
            name: 'assignmentProgress.devTags.ms_pn_adult_for_help',
            label: 'Adult for Help',
            tooltip: 'Please share the name of an adult at school you are comfortable going to if you need help.',
            sort: true,
            filter: true,
            width: '30%',
        },
        {
            name: 'assignmentProgress.devTags.ms_pn_teacher_to_know',
            label: 'Teacher to Know',
            tooltip: 'Is there any information you would like your teachers to know as you start the new year?',
            sort: true,
            filter: true,
            width: '30%',
        },
    ];

    return (
        <div>
            <div className={'mt-4 mb-3 alert alert-info ' + style.alertWidth}>
                <p className="mb-0">
                    This table only includes students from{' '}
                    <b>
                        {classIdsWithMsClimateSurvey.length}{' '}
                        {classIdsWithMsClimateSurvey.length === 1 ? labelSingle : labelPlural}
                    </b>{' '}
                    who have been assigned the Middle School Nominations Survey.
                </p>
            </div>
            {renderTimepointPills()}
            <Table
                name={'ms-noms-table-' + currTimepoint}
                query={query}
                columns={columns}
                rowKey="pawn.pawnId"
                graphqlVariables={{ timepoint: currTimepoint, classIds: classIdsWithMsClimateSurvey }}
            />
        </div>
    );
};

MSNominationsTab.propTypes = {
    currTimepoint: PropTypes.string,
    renderTimepointPills: PropTypes.func,
    classIdsWithMsClimateSurvey: PropTypes.arrayOf(PropTypes.number),
};

export default MSNominationsTab;
